import React from 'react';

import { IFormFieldInputBaseProps } from '@components/form-fields';
import { MAIN_THEME } from '@styles';

import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

type SeparatorVariant = 'block' | 'line';

export interface ISeparatorProps extends IFormFieldInputBaseProps {
  variant?: SeparatorVariant;
}

const useStyles = makeStyles()(() => ({
  separator: {
    width: '100%',
    margin: '10px 0'
  },
  block: {
    background: `${MAIN_THEME.color.white98} 0% 0% no-repeat padding-box`,
    height: 10
  },
  line: {
    borderBottom: '1px solid #747474',
    height: 0
  }
}));

const Separator: React.FC<ISeparatorProps> = ({
  className,
  style,
  variant = 'block'
}) => {
  const { classes } = useStyles();

  return (
    <div
      className={clsx(classes.separator, classes[variant], className)}
      style={style}
    />
  );
};

export default Separator;
